import {
  GOODS_DECREASE,
  GOODS_INCREASE,
  GOODS_SET_COUNT,
} from '@/action-types/goods'
interface Action {
  type: string
  count: string | number
}
interface State {
  count: number
}
const initGoodsState = {
  count: 0,
}
const goods = (state: State = initGoodsState, action: Action) => {
  const count = parseInt(action.count as string)
  switch (action.type) {
    // 备用，前端控制商品总数
    case GOODS_DECREASE:
      return Object.assign({}, state, {
        count: state.count - 1 < 0 ? 0 : state.count - 1,
      })
    case GOODS_INCREASE:
      return Object.assign({}, state, { count: state.count + 1 })
    case GOODS_SET_COUNT:
      return Object.assign({}, state, { count: count })
    default:
      return state
  }
}
export { goods }
